exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".printBarcode{width:200px;height:25px}", ""]);

// exports
